// N42 (08-10) — « un ordre est-il en cours sur ce logement ? » : le caddie de la fenêtre de validation.
//
// La règle, tranchée par le user le 08-10 après lecture de la sonde : ce qu'on veut savoir, c'est qu'un logement
// PAS ENCORE Homes Connect attend son raccordement. Un logement déjà Homes Connect n'intéresse plus (« il a été
// fait, donc on s'en fout ») — résiliations, patchs et changements de splitter en cours n'y paraissent donc pas.
//
// Elle vit ICI, une seule fois : le serveur s'en sert pour ne rendre que les ordres en cours, l'écran pour décider
// du caddie. Deux copies finiraient par ne plus dire la même chose.
/**
 * Les statuts qui CLOSENT un ordre. C'est une liste d'EXCLUSION, à dessein : la sonde du 08-10 a compté sept
 * statuts dans `public.product_order`, mais l'historique en montre deux de plus, de passage (ACCEPTED,
 * TO_CONSTRUCTOR) — une liste blanche bâtie sur le comptage les aurait ratés. Un statut que personne n'a encore
 * vu compte donc comme « en cours » : mieux vaut un caddie de trop qu'un ordre touché par mégarde.
 *
 * TECHNICALLY_EXECUTED y figure : l'ordre est exécuté, il n'attend plus que sa clôture (1 150 ordres le 08-10,
 * aucun créé depuis 90 jours).
 */
export const CLOSED_ORDER_STATUSES = ['DELIVERED', 'CANCELLED', 'TECHNICALLY_EXECUTED'];
const norm = (v) => (v ?? '').trim().toUpperCase();
/** Cet ordre est-il encore en cours ? Un statut vide ou inconnu répond OUI. */
export function isOpenOrderStatus(status) {
    return !CLOSED_ORDER_STATUSES.includes(norm(status));
}
/**
 * Ce logement porte-t-il le caddie ? Au moins un ordre en cours ET un logement qui n'est pas Homes Connect.
 * Le statut du logement est celui que la ligne AFFICHE déjà : le caddie ne peut pas contredire la colonne Statut.
 * Sans statut (ou NOT_AVAILABLE), le caddie s'affiche — la règle est « pas Homes Connect », pas « Homes Passed ».
 */
export function unitShowsOpenOrderCart(unitStatus, orders) {
    if (!orders?.some((o) => isOpenOrderStatus(o.orderStatus)))
        return false;
    return norm(unitStatus) !== 'HOMES_CONNECT';
}
//# sourceMappingURL=open-orders.js.map